var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    preserveAspectRatio: "xMidYMid",
    id: "svgcontent",
    x: 500,
    y: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Tor Browser") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#420C5D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#951AD1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#420C5D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#951AD1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "NaN",
    y1: "100%",
    x2: "NaN",
    y2: "0%",
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#420C5D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#951AD1",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      pointerEvents: "all"
    }
  }, /*#__PURE__*/React.createElement("title", {
    style: {
      pointerEvents: "inherit"
    }
  }, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    style: {
      pointerEvents: "inherit"
    },
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#F2E4FF",
    cx: 128,
    cy: 128,
    r: 123,
    style: {
      pointerEvents: "inherit"
    },
    id: "svg_3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.26257,232.71985L128.26257,217.20331C177.41309,217.06137 217.2104,177.18246 217.2104,127.99645C217.2104,78.81399 177.41309,38.93508 128.26257,38.79315L128.26257,23.2766C185.98215,23.42208 232.7234,70.24494 232.7234,127.99645C232.7234,185.75151 185.98215,232.57792 128.26257,232.71985zM128.26257,178.41016C155.98514,178.26468 178.42435,155.75805 178.42435,127.99645C178.42435,100.2384 155.98514,77.73177 128.26257,77.5863L128.26257,62.07329C164.55774,62.21522 193.9409,91.66935 193.9409,127.99645C193.9409,164.3271 164.55774,193.78123 128.26257,193.92316L128.26257,178.41016zM128.26257,100.85934C143.13334,101.00128 155.1513,113.0902 155.1513,127.99645C155.1513,142.90625 143.13334,154.99518 128.26257,155.13711L128.26257,100.85934zM0,127.99645C0,198.69202 57.30443,256 128,256C198.69202,256 256,198.69202 256,127.99645C256,57.30443 198.69202,0 128,0C57.30443,0 0,57.30443 0,127.99645z",
    fill: "url(#a)",
    style: {
      pointerEvents: "inherit"
    },
    id: "svg_4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,14.5 C64.21111,14.5 12.5,65.98725 12.5,129.5 C12.5,193.01275 64.21111,244.5 128,244.5 L128,14.5 z",
    fill: "url(#svg_1)",
    style: {
      pointerEvents: "inherit"
    },
    id: "svg_5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTor);
export default __webpack_public_path__ + "static/media/tor.62b01c755a52ed46636071730a0f7609.svg";
export { ForwardRef as ReactComponent };